




import { sanitizeFilename } from "../sanitizeFilename";

function formatQuestionStem(variation) {
  const { question, questionEmphasis } = variation.coreContent;
  if (!questionEmphasis) {
    return question;
  }
  return `${question} ${questionEmphasis}`;
}

function variationSlides(variations) {
  return variations.flatMap((variation) => [
  {
    kind: "section",
    title: variation.versionLabel,
    body: [variation.header.title, variation.header.contextLine].filter(Boolean).join("\n")
  },
  {
    kind: "section",
    title: "Purpose / Objective",
    body: variation.purpose
  },
  {
    kind: "bullets",
    title: "Core Content",
    body: formatQuestionStem(variation),
    bullets: [
    ...variation.coreContent.options,
    `Correct Answer: ${variation.coreContent.correctAnswer}`]

  },
  {
    kind: "bullets",
    title: "Usage / Implementation Guidance",
    bullets: variation.usage.map((row) => `${row.label}: ${row.body}`)
  },
  {
    kind: "bullets",
    title: "Supporting Elements",
    bullets: variation.supporting.map((row) => `${row.label}: ${row.body}`)
  },
  {
    kind: "bullets",
    title: "Quick Check / Validation",
    bullets: variation.quickCheck
  },
  {
    kind: "section",
    title: "Optional Tip",
    body: variation.optionalTip
  }]
  );
}

export function questionVariationsToPptDocument(
result)
{
  const slides = [
  {
    kind: "title",
    title: result.title,
    subtitle: [result.curriculumLabel, result.subtitle].filter(Boolean).join("\n")
  },
  {
    kind: "section",
    title: "Question Variations",
    body: `${result.variations.length} MCQ versions for classroom use.`
  },
  ...variationSlides(result.variations)];


  return {
    filename: sanitizeFilename(result.title, "question-variations"),
    title: result.title,
    subject: result.curriculumLabel,
    author: "Tema Question Variations",
    slides
  };
}